export default __webpack_public_path__ + "static/media/2280.249831da.png";